import React from 'react';
import { TrendingUp, Users, Heart, MessageCircle, Share2 } from 'lucide-react';

export default function SocialMediaAnalytics() {
  // Mock data for analytics
  const platformStats = {
    instagram: {
      followers: 2500,
      engagement: 4.8,
      posts: 150,
      likes: 12500,
      comments: 850,
    },
    facebook: {
      followers: 3800,
      engagement: 3.2,
      posts: 120,
      likes: 9800,
      shares: 450,
    },
    youtube: {
      subscribers: 1200,
      views: 25000,
      videos: 45,
      likes: 3200,
      comments: 620,
    },
  };

  return (
    <div className="space-y-6">
      {/* Vue d'ensemble */}
      <div className="bg-white shadow rounded-lg p-6">
        <h2 className="text-lg font-medium mb-6">Vue d'ensemble</h2>
        <div className="grid grid-cols-4 gap-6">
          <div className="p-4 bg-blue-50 rounded-lg">
            <div className="flex items-center">
              <Users className="w-8 h-8 text-blue-600" />
              <div className="ml-4">
                <p className="text-sm text-gray-500">Total abonnés</p>
                <p className="text-2xl font-semibold">7.5K</p>
              </div>
            </div>
          </div>
          <div className="p-4 bg-green-50 rounded-lg">
            <div className="flex items-center">
              <TrendingUp className="w-8 h-8 text-green-600" />
              <div className="ml-4">
                <p className="text-sm text-gray-500">Engagement moyen</p>
                <p className="text-2xl font-semibold">4.2%</p>
              </div>
            </div>
          </div>
          <div className="p-4 bg-pink-50 rounded-lg">
            <div className="flex items-center">
              <Heart className="w-8 h-8 text-pink-600" />
              <div className="ml-4">
                <p className="text-sm text-gray-500">Total likes</p>
                <p className="text-2xl font-semibold">25.5K</p>
              </div>
            </div>
          </div>
          <div className="p-4 bg-purple-50 rounded-lg">
            <div className="flex items-center">
              <MessageCircle className="w-8 h-8 text-purple-600" />
              <div className="ml-4">
                <p className="text-sm text-gray-500">Commentaires</p>
                <p className="text-2xl font-semibold">2.1K</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Statistiques par plateforme */}
      <div className="bg-white shadow rounded-lg p-6">
        <h2 className="text-lg font-medium mb-6">Statistiques par plateforme</h2>
        <div className="space-y-6">
          {/* Instagram */}
          <div className="border-b pb-6">
            <h3 className="text-lg font-medium mb-4">Instagram</h3>
            <div className="grid grid-cols-5 gap-4">
              <div>
                <p className="text-sm text-gray-500">Abonnés</p>
                <p className="text-xl font-semibold">{platformStats.instagram.followers}</p>
              </div>
              <div>
                <p className="text-sm text-gray-500">Engagement</p>
                <p className="text-xl font-semibold">{platformStats.instagram.engagement}%</p>
              </div>
              <div>
                <p className="text-sm text-gray-500">Publications</p>
                <p className="text-xl font-semibold">{platformStats.instagram.posts}</p>
              </div>
              <div>
                <p className="text-sm text-gray-500">Likes</p>
                <p className="text-xl font-semibold">{platformStats.instagram.likes}</p>
              </div>
              <div>
                <p className="text-sm text-gray-500">Commentaires</p>
                <p className="text-xl font-semibold">{platformStats.instagram.comments}</p>
              </div>
            </div>
          </div>

          {/* Facebook */}
          <div className="border-b pb-6">
            <h3 className="text-lg font-medium mb-4">Facebook</h3>
            <div className="grid grid-cols-5 gap-4">
              <div>
                <p className="text-sm text-gray-500">Abonnés</p>
                <p className="text-xl font-semibold">{platformStats.facebook.followers}</p>
              </div>
              <div>
                <p className="text-sm text-gray-500">Engagement</p>
                <p className="text-xl font-semibold">{platformStats.facebook.engagement}%</p>
              </div>
              <div>
                <p className="text-sm text-gray-500">Publications</p>
                <p className="text-xl font-semibold">{platformStats.facebook.posts}</p>
              </div>
              <div>
                <p className="text-sm text-gray-500">Likes</p>
                <p className="text-xl font-semibold">{platformStats.facebook.likes}</p>
              </div>
              <div>
                <p className="text-sm text-gray-500">Partages</p>
                <p className="text-xl font-semibold">{platformStats.facebook.shares}</p>
              </div>
            </div>
          </div>

          {/* YouTube */}
          <div>
            <h3 className="text-lg font-medium mb-4">YouTube</h3>
            <div className="grid grid-cols-5 gap-4">
              <div>
                <p className="text-sm text-gray-500">Abonnés</p>
                <p className="text-xl font-semibold">{platformStats.youtube.subscribers}</p>
              </div>
              <div>
                <p className="text-sm text-gray-500">Vues totales</p>
                <p className="text-xl font-semibold">{platformStats.youtube.views}</p>
              </div>
              <div>
                <p className="text-sm text-gray-500">Vidéos</p>
                <p className="text-xl font-semibold">{platformStats.youtube.videos}</p>
              </div>
              <div>
                <p className="text-sm text-gray-500">Likes</p>
                <p className="text-xl font-semibold">{platformStats.youtube.likes}</p>
              </div>
              <div>
                <p className="text-sm text-gray-500">Commentaires</p>
                <p className="text-xl font-semibold">{platformStats.youtube.comments}</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Meilleures publications */}
      <div className="bg-white shadow rounded-lg p-6">
        <h2 className="text-lg font-medium mb-6">Meilleures publications</h2>
        <div className="space-y-4">
          {/* Exemple de meilleure publication */}
          <div className="border rounded-lg p-4">
            <div className="flex items-center justify-between mb-4">
              <div className="flex items-center space-x-2">
                <span className="text-pink-600">Instagram</span>
                <span className="text-sm text-gray-500">• il y a 2 jours</span>
              </div>
              <div className="flex items-center space-x-4">
                <div className="flex items-center">
                  <Heart className="w-4 h-4 text-pink-600 mr-1" />
                  <span>1.2K</span>
                </div>
                <div className="flex items-center">
                  <MessageCircle className="w-4 h-4 text-blue-600 mr-1" />
                  <span>89</span>
                </div>
                <div className="flex items-center">
                  <Share2 className="w-4 h-4 text-green-600 mr-1" />
                  <span>45</span>
                </div>
              </div>
            </div>
            <p className="text-gray-900">Découvrez notre nouvelle destination : Les Maldives ! 🌊✨</p>
          </div>
        </div>
      </div>
    </div>
  );
}